import logger from '../../log';
import { NodeData } from './data';

const log = logger.getLogger(__filename);

// Variant in cpp
// using AgentMessage = variant<
//         monostate,
//         content::PeerObjectRequest,
//         content::PeerObjectResponse,
//         content::GraphObjectRequest,
//         content::ObjectNotification,
//         content::AgentEvent,
//         content::FetchRequest,
//         peering::PeerOffer,
//         peering::PeerResponse,
//         peering::ClosePeer,
//         peering::CandidateRequest,
//         peering::CandidateResponse,
//         peering::CandidateNotification,
//         peering::PeerDetach,
//         peering::PeerStateUpdate,
//         core::Timeout,
//         coordinator::AttachmentResponse>;
type AgentMessage = any;

interface WasmKernelNode {
  GetNode(): NodeData;
  PushMessage(msg: { type: string; body: AgentMessage }): void;
  InitiateAttachment(): void;
  Close(): void;
  delete(): void;
}

export class KernelNode {
  kernel: WasmKernelNode;

  constructor(kernelNode: WasmKernelNode) {
    this.kernel = kernelNode;
  }

  initiateAttachment(): void {
    this.kernel.InitiateAttachment();
  }

  pushMessage(type: string, body: AgentMessage): void {
    const msg = { type, body };
    try {
      if (this.kernel) {
        log.trace('Pushing message to kernel: ', msg);
        this.kernel.PushMessage(msg);
        log.trace('Back in agent scope');
      }
    } catch (e) {
      log.warn('Error pushing message to kernel: ', msg, e);
    }
  }

  getNode(): NodeData {
    return this.kernel.GetNode();
  }

  close(): void {
    this.kernel.Close();

    try {
      this.kernel.delete(); // Delete the wasm cpp memory reference
    } catch (e) {
      log.warn('Could not delete the kernel node');
    }
  }
}
